"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Email() {
    return (react_1.default.createElement("svg", { width: "56", height: "56", viewBox: "0 0 56 56" },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(0 -13.142)" },
            react_1.default.createElement("rect", { width: "56", height: "56", y: "13.142" }),
            react_1.default.createElement("g", { transform: "translate(3.013)" },
                react_1.default.createElement("rect", { width: "50", height: "40", x: "-.013", y: "21.142", fill: "#F5F5F5", stroke: "#BFBFBF", strokeWidth: "2" }),
                react_1.default.createElement("rect", { width: "48", height: "4", x: "1", y: "22", fill: "#FFF" }),
                react_1.default.createElement("polyline", { fill: "#FFF", stroke: "#BFBFBF", strokeWidth: "2", points: "42.625 7.325 38.381 38.344 7.297 42.597", transform: "rotate(45 24.96 24.96)" })))));
}
exports.default = Email;
//# sourceMappingURL=Email.js.map